import { render, staticRenderFns } from "./crisp-chat.vue?vue&type=template&id=60463918"
import script from "./crisp-chat.vue?vue&type=script&lang=js"
export * from "./crisp-chat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports